// TODO: remover — token de debug para testar a tela de notificações com um
// usuário que possua notificações. A chave precisa ser minúscula
// (`authorization`) para sobrescrever o header injetado automaticamente pelo

import { AppConfig } from "@/config";

// RemoteDataSource — caso contrário, os dois headers vão juntos e dá 401.
export const notifHeaders = (): Record<string, string> => ({
  Accept: "application/vnd.data.full.v1+json",
  authorization: `Bearer ${AppConfig.tokenAcesso}`,
});
